export default "__VITE_ASSET__ec8ced93__"